module.exports = __webpack_public_path__ + "asset/image-Calculator-e6a4a314adc38e43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Calculator.svg
// module id = DChA
// module chunks = 0